import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';

import { UtilsService } from '@shared/providers/utils.service';

@Component({
  selector: 'app-survey-immobile-form',
  templateUrl: './survey-immobile-form.component.html',
  styleUrls: ['./survey-immobile-form.component.scss'],
})
export class SurveyImmobileFormComponent implements OnInit {
  public immobileForm: FormGroup;

  @Input() formImmobileData;
  @Output() submitEvent = new EventEmitter();
  public editorConfig = environment.editorConfig;

  get surveyObservations() {
    return this.immobileForm.get('surveyObservations');
  }

  get surveyDescription() {
    return this.immobileForm.get('surveyDescription');
  }
  constructor(
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    this.immobileForm = this.initializeForm();
    if (this.formImmobileData) {
      this.immobileForm.patchValue(this.formImmobileData);
    }
  }

  initializeForm(): FormGroup {
    return this.formBuilder.group({
      surveyObservations: ['', [Validators.maxLength(3000)]],
      surveyDescription: ['', [Validators.maxLength(3000)]],
    });
  }

  async submit(form: FormGroup) {
    if (form.invalid) {
      this.utils.validateAllFields(form);
      this.utils.showToast('', `${this.translate.instant('COMPONENTS.FORMS.CHECK_THE_FIELDS')}`);
    } else {
      this.submitEvent.emit(form.getRawValue());
    }
  }
}
